var React = require('react');

function UpDown (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.584 7.21582L16.84 3.00078L21.0961 7.21582","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M16.8384 3.00031V12.8356","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M13.2211 19.7373L8.96503 23.9523L4.70898 19.7373","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M8.96539 23.9522V14.1171","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

UpDown.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = UpDown;

UpDown.default = UpDown;
